import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Navbar1 from './components/Navbar1'
import Register from './pages/Register';
import Home from './pages/Home';
import Login from './pages/Login';
import Footer from "./components/Footer";

import VideoDescription from './pages/VideoDescription';
import Isldescription from './pages/Isldescription';
import Dashboard from './pages/Dashboard';
import Fileupload from './pages/Fileupload';
import Islvideo from './pages/Islvideo';
import AudioConverter from './pages/AudioConverter';
import Isldashboard from './pages/Isldashboard';
import IslLive from './pages/IslLive';
import { Navbar } from 'react-bootstrap';
import { UserProvider } from "./jsx/UserContext";

// import AdEdit from './pages/AdEdit';
 import AudioDescriptionEdit from './components/AudioDescriptionEdit';
import Expert from './pages/Expert';


function App() {
  const [userSession, setUserSession] = useState({
    name: localStorage.getItem("name") || "",
    access_token: localStorage.getItem("access_token") || "",
  });

  
  useEffect(() => {
    localStorage.setItem("name", userSession.name);
    localStorage.setItem("access_token", userSession.access_token);
  }, [userSession]);

  return (
   <UserProvider value={{ userSession, setUserSession }}>
      <Router>

      
        {/* <div className="page-wrapper">
          <div className="content-wrapper"> */}

            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/register" element={<Register />} />
              <Route path="/login" element={<Login />} />
              <Route path="/videodescription/:id" element={<VideoDescription />} />
              <Route path="/Isldescription/:id" element={<Isldescription />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/navbar" element={<Navbar />} />
              <Route path="/navbar1" element={<Navbar1 />} />
              <Route path="/fileupload" element={<Fileupload />} />
              <Route path="/islvideo" element={<Islvideo />} />
              <Route path="/audio-converter" element={<AudioConverter />} />
              <Route path="/Isldashboard" element={<Isldashboard />} />
              {/* <Route path= "/AdEdit" element={<AdEdit/>} /> */}
              <Route path="/Expert/:id" element={<Expert />} />

              <Route path= "/AudioDescriptionEdit" element={<AudioDescriptionEdit/>} />
              <Route path="/IslLive" element={<IslLive />} />


            </Routes>

          {/* </div> */}

          {/* FOOTER */}
          {/* <Footer /> */}

        {/* </div> */}
      </Router>
    </UserProvider>
  );
}

export default App;
